import React, { memo, Fragment, useState } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, Text } from '@redlink/components/atoms';

export const MultiProgress = memo(({ data }) => {
  const { styles } = useStyle();
  const [containerWidth, setContainerWidth] = useState(0);

  const total = data.reduce((prev, { value }) => prev + value, 0);

  return (
    <View
      style={styles.container}
      onLayout={({
        nativeEvent: {
          layout: { width },
        },
      }) => setContainerWidth(width)}
    >
      <View style={styles.percentsContainer}>
        {data.map(({ value, color }, index) => {
          const width = (containerWidth * value) / total;
          return <View style={[{ backgroundColor: color, width }]} />;
        })}
      </View>
      <Space />
      <View style={styles.flagsContainer}>
        {data.map(({ title, value, color, logo }, index) => {
          const percent = Math.floor((value / total) * 100);
          return (
            <Fragment key={index}>
              <View style={styles.flagItemContainer}>
                {logo}
                <Space size={8} />
                <Text style={styles.statBlockTitleText}>{title}</Text>
                <Text style={styles.statBlockTitleText}>{`${percent}%`}</Text>
              </View>
              <Space />
            </Fragment>
          );
        })}
      </View>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {},
  flagsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  flagIndicaor: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  percentsContainer: {
    flexDirection: 'row',
    height: 24,
    borderRadius: 5,
    overflow: 'hidden',
  },
  flagItemContainer: {
    alignItems: 'flex-start',
  },
  statBlockTitleText: {
    color: colors.black
  }
}));
